import { DeviceType } from '@/src/types/deviceType'
import { Benefit } from '@/src/types/itinerary'
import { TranslationFunction } from '@/src/types/translations'
import dynamic from 'next/dynamic'
import { useState } from 'react'

const InsuranceItemDesktop = dynamic(() => import(/* webpackChunkName: "insurance-item-desktop" */ './insuranceItem'), {
    ssr: true
})

const InsuranceItemMobile = dynamic(
    () =>
        import(/* webpackChunkName: "insurance-item-mobile" */ '../../../../mobile/itinerary/insurance/insuranceItem'),
    {
        ssr: true
    }
)
const InsuranceItemWrapper = ({
    id,
    onInsuranceClick,
    imageSrc,
    title,
    shortDescription,
    description,
    totalPremiumAmount,
    isSelected,
    t,
    deviceType,
    benefits
}: {
    id: string
    onInsuranceClick: () => void
    imageSrc: string
    title: string
    shortDescription: string
    description: string
    totalPremiumAmount: string
    isSelected: boolean
    t: TranslationFunction<'common'>
    deviceType: DeviceType
    benefits: Benefit[]
}) => {
    const addTitle = t('add')
    const removeTitle = t('remove')
    const viewBenefitsTitle = t('viewBenefits')
    const [showBenefitModal, setShowBenefitModal] = useState(false)

    return deviceType === 'DESKTOP' ? (
        <InsuranceItemDesktop
            id={id}
            onInsuranceClick={onInsuranceClick}
            imageSrc={imageSrc}
            title={title}
            shortDescription={shortDescription}
            description={description}
            totalPremiumAmount={totalPremiumAmount}
            isSelected={isSelected}
            addTitle={addTitle}
            removeTitle={removeTitle}
            showBenefitModal={showBenefitModal}
            setShowBenefitModal={setShowBenefitModal}
            viewBenefitsTitle={viewBenefitsTitle}
        />
    ) : (
        <InsuranceItemMobile
            id={id}
            onInsuranceClick={onInsuranceClick}
            imageSrc={imageSrc}
            title={title}
            shortDescription={shortDescription}
            description={description}
            totalPremiumAmount={totalPremiumAmount}
            isSelected={isSelected}
            addTitle={addTitle}
            removeTitle={removeTitle}
            showBenefitModal={showBenefitModal}
            setShowBenefitModal={setShowBenefitModal}
            viewBenefitsTitle={viewBenefitsTitle}
        />
    )
}

export default InsuranceItemWrapper
